import { supportData } from "constants/support"

export default function useSupportURL() {
  return supportData.supportDocURL
}
